// extracted by mini-css-extract-plugin
export default {"kontaktGrid":"kontakt_kontaktGrid__Y50pu","textSide":"kontakt_textSide__e4paS","kontaktButtons":"kontakt_kontaktButtons__ZgKa8","picture":"kontakt_picture__Sfo-o"};